export const mapButtonViewToLoaderView = {
    primary: "primaryOnColor",
    custom: "custom",
    secondary: "primary",
    tertiary: "custom",
    "primary-on-color": "custom",
    negative: "custom",
    destructive: "primaryOnColor",
} as const;
